module.exports = function() {
  return new Worker(__webpack_public_path__ + "0c20d02ae45db54c5849.worker.js");
};